import { render, staticRenderFns } from "./detailButton.vue?vue&type=template&id=457aca1c&"
import script from "./detailButton.vue?vue&type=script&lang=ts&"
export * from "./detailButton.vue?vue&type=script&lang=ts&"
import style0 from "./detailButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports